/** Default landing path after login or when visiting `/`. */
export function getHomePathForRole(role) {
  const r = typeof role === "string" ? role.trim().toLowerCase() : "";
  if (r === "admin") return "/dashboard";
  if (r === "manager") return "/form";
  if (r === "designer") return "/brands";
  return "/login";
}
